import { AsyncPipe, NgOptimizedImage, LowerCasePipe, NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { RouterOutlet } from '@angular/router'
import { ConnectionService } from '@app-services/connection/connection.service'
import { TabletIdentifierService } from '@app-services/tablet-identifier/tablet-identifier.service'
import { Observable, switchMap, merge, of, delay, tap } from 'rxjs'
import { ParagraphDirective } from './domains/ui/directives'
import { ReloaderAppService, reloadTimeInMilliseconds } from '@app-services/reloader-app/reloader-app.service'
import { addMilliseconds } from 'date-fns'
import { TimeLeftPipe } from '@app-pipes/time-left.pipe'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgOptimizedImage, ParagraphDirective, AsyncPipe, MatIcon, LowerCasePipe, TimeLeftPipe, NgIf],
    templateUrl: './app.component.html',
    standalone: true,
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

    public tabletIdentifier$: Observable<string | null>
    public networkStatus$: Observable<any>

    public refreshingPageTime$: Observable<Date | null>;

    constructor(
        private tabletIdentifierService: TabletIdentifierService,
        private connectionService: ConnectionService,
        private reloaderAppService: ReloaderAppService
    ) {
    }

    public ngOnInit(): void {
        this.tabletIdentifier$ = this.tabletIdentifierService.identifier$
        this.networkStatus$ = this.connectionService.networkStatus$

        this.setRefreshingPageTime()
    }

    private setRefreshingPageTime(): void {
        this.refreshingPageTime$ = this.reloaderAppService.getAppNeedsToReload$().pipe(
            switchMap(() => merge(
                of(addMilliseconds(new Date(), reloadTimeInMilliseconds)),
                of(null).pipe(delay(reloadTimeInMilliseconds), tap(() => location.reload())),
            )),
        );
    }
}
